export default __webpack_public_path__ + "static/media/StatsImage.80e6fe0b.svg";